<template>
  <div class="chat-convo-wrap">
    <div class="chat-convo-content" v-if="selectedConversation">
      <ConvoHead
        ref="convoHead"
        :selected-conversation="selectedConversation"
        @go-back="goback"
        @message-search="handleMessageSearch"
        @clear-conversation="handleConversationClear"
        @type-on-search="handleTypeOnSearch"
        :basic-player="
            senderProfile.uniqueSlug !== 'clubCoach' &&
            selectedConversation.receiverId.uniqueSlug === 'athlete' &&
            selectedConversation.receiverId.profileType === 'Basic'
          "
      />
      <BaseLoading  :spinning="messagesLoading">
        <ConvoBody
          ref="convoBody"
          :messages="messages"
          :typing="typing"
          :scroll="scroll"
          :force-scroll="forceScroll"
          :searched-message="searchedMessage"
          :search-query="searchQuery"
          :deactivated="
            selectedConversation.receiverId.isDeleted ||
              (selectedConversation.receiverId.isActive !== undefined &&
                !selectedConversation.receiverId.isActive) ||
              selectedConversation.receiverId.isDeactivated
          "
          :blocked="blocked"
          :basic-player="
            senderProfile.uniqueSlug !== 'clubCoach' &&
              selectedConversation.receiverId.uniqueSlug === 'athlete' &&
              selectedConversation.receiverId.profileType === 'Basic'
          "
          :sender-is-basic-player="
            senderProfile.uniqueSlug === 'athlete' &&
              senderProfile.profileType === 'Basic'
          "
          :latest-message-read="
            selectedConversationInContactList &&
              selectedConversationInContactList.isRead
          "
          :latest-message-id="
            selectedConversationInContactList &&
              selectedConversationInContactList.lastMessageId.Id
          "
          :receiver-is-club-coach="
            selectedConversation.receiverId.uniqueSlug == 'clubCoach'
          "
          :sender-is-club-coach="senderProfile.uniqueSlug == 'clubCoach'"
          :selected-conversation="selectedConversation"
          :inactive-users-shown="inactiveUsersShown"
          @scroll-top="handleScrollTop"
          @scroll-bottom="handleScrollBottom"
        />
      </BaseLoading>
      <ConvoFooter
        :blocked="blocked"
        :deactivated="
          selectedConversation.receiverId.isDeleted ||
            (selectedConversation.receiverId.isActive !== undefined &&
              !selectedConversation.receiverId.isActive) ||
            selectedConversation.receiverId.isDeactivated
        "
        :basic-player="
          senderProfile.uniqueSlug !== 'clubCoach' &&
            selectedConversation.receiverId.uniqueSlug === 'athlete' &&
            selectedConversation.receiverId.profileType === 'Basic'
        "
        :sender-is-basic-player="
          senderProfile.uniqueSlug === 'athlete' &&
            senderProfile.profileType === 'Basic'
        "
        :sender-is-club-coach="senderProfile.uniqueSlug == 'clubCoach'"
        :receiver-is-club-coach="
          selectedConversation.receiverId.uniqueSlug == 'clubCoach'
        "
        @type="handleMessageType"
        @send="handleMessageSend"
      />
    </div>
    <div class="empty-convo" v-else>
      <div class="img-wrap">
        <img src="@/assets/icons/chat.svg" alt="chat" />
      </div>
      <div class="text-detail">
        <div class="text-title">Nothing to show.</div>
        <div class="text-description">
          Select one of the person to start chatting.
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ConvoHead from "./convohead";
import ConvoBody from "./convobody";
import ConvoFooter from "./convofooter";
import { mapGetters } from "vuex";
import { Message } from "@/models";

const STORE_KEY = "chatStore";

export default {
  name: "ChatConvo",
  components: {
    ConvoHead,
    ConvoBody,
    ConvoFooter
  },
  props: {
    selectedConversation: {
      type: Object,
      default: null
    },
    typing: {
      type: Boolean,
      default: false
    },
    scroll: {
      type: Number,
      default: 0
    },
    forceScroll: {
      type: Number,
      default: 0
    },
    inactiveUsersShown: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapGetters({
      contactList: `${STORE_KEY}/contacts`,
      messages: `${STORE_KEY}/messages`,
      messagesLoading: `${STORE_KEY}/messagesLoading`,
      currentPage: `${STORE_KEY}/currentPage`,
      messagePageLoading: `${STORE_KEY}/messagePageLoading`,
      currentPageMessages: `${STORE_KEY}/currentPageMessages`,
      pageHistory: `${STORE_KEY}/pageHistory`,
      senderProfile: `${STORE_KEY}/senderProfile`
    }),
    blocked() {
      return (
        this.selectedConversation &&
        this.selectedConversation.blockBy &&
        this.selectedConversation.blockBy.length > 0
      );
    },
    selectedConversationInContactList() {
      return this.contactList.find(
        conversation => conversation.id === this.selectedConversation.id
      );
    }
  },
  data() {
    return {
      activeKey: 1,
      empty: false,
      searchedMessage: null,
      searchQuery: ""
    };
  },
  methods: {
    goback() {
      this.$emit("listview");
    },
    changeUser(val) {
      this.activeKey = val;
    },
    handleMessageType(value) {
      this.$emit("type", value);
    },
    handleMessageSend(message) {
      this.$emit("send-message", message);
    },
    handleMessageSearch(message) {
      this.searchedMessage = new Message({ ...message });
    },
    handleScrollTop() {
      if (this.currentPageMessages.length === 0) return;
      this.$store.dispatch(`${STORE_KEY}/increaseCurrentMessagePage`);
    },
    handleScrollBottom() {
      this.$store.dispatch(`${STORE_KEY}/decreaseCurrentMessagePage`);
    },
    handleConversationClear() {
      this.$emit("clear-conversation");
    },
    handleTypeOnSearch(query) {
      this.searchQuery = query;
    }
  },
  watch: {
    selectedConversation: {
      deep: true,
      handler: async function() {
        this.$store.dispatch(`${STORE_KEY}/clearSearchedMessages`);
        this.$refs.convoHead && this.$refs.convoHead.clearSearchQuery();
      }
    },
    currentPage(newVal) {
      if (this.pageHistory.includes(newVal)) return;
      this.$store.dispatch(`${STORE_KEY}/pushPageHistory`, newVal);
      const room = [
        this.selectedConversation.senderId,
        this.selectedConversation.receiverId.Id
      ]
        .sort()
        .join("");
      this.$store.dispatch(`${STORE_KEY}/getMessages`, {
        room,
        sort: "-createdAt",
        userId: this.selectedConversation.senderId,
        limit: Message.LIMIT,
        page: newVal
      });
    }
  }
};
</script>

<style lang="scss">
.chat-convo-wrap {
  position: relative;
  border: 1px solid #dadce0;
  border-left: none;
  height: calc(100vh - 40px);
  padding-bottom: 63px;
    @media (max-width:644px) {
  height: calc(100vh - 10px);
  }

  @media (max-width:285px) {
    height: calc(100vh - 10px);
  }
  .convo-panel-footer .send-message-input textarea{
    padding: 4px 4px 3px !important;
  }

  .empty-convo {
    height: 100%;
    min-height: 373px;
    overflow-y: scroll;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    .img-wrap {
      width: 100%;
      padding: 0 40px;
      max-width: 450px;
      margin: 0 auto;
    }
    .text-detail {
      text-align: center;
      padding: 0 20px;
      .text-title {
        font-size: 16px;
        font-weight: 500;
        color: #000;
        padding-bottom: 10px;
      }
      .text-description {
        font-size: 14px;
        font-weight: 400;
        color: #565656;
      }
    }
  }
}
</style>
